// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"PopoverTrigger_ProseMirror__2GriI","popover-trigger":"PopoverTrigger_popover-trigger__2LxcM","popover-header":"PopoverTrigger_popover-header__1CPLb"};